import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Form, Toggle } from "rsuite";
import { TagWriteInput, TextInput } from "../../components/textInput.component";
import { AppRouteUi } from "../../config/appRoute";
import {
  InsuranceFormType,
  InsuranceFormSchema,
} from "../../models/forms/insurance";
import { DoesObjectHasAnyInvalidValue } from "../../utils/formUtils";
import { Button } from "../../components/button.component";

export const InsuranceForm = ({
  value,
  onChange,
  handleSave,
}: {
  value?: InsuranceFormType;
  onChange: (value: InsuranceFormType) => void;
  handleSave: (data: InsuranceFormType) => Promise<void>;
}) => {
  const routeHistory = useHistory();
  const [formError, setFormError] = useState({});
  const [formData, setFormData] = useState(value);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => setFormData(value), [value]);

  useEffect(() => {
    if (!formData) {
      setIsDisabled(true);
      return;
    }
    const { isDisabled: _, code, ...rest } = formData;
    const isEmpty = Object.values(rest).some(DoesObjectHasAnyInvalidValue);
    const errorCount = Object.keys(formError).length;
    var isDisabled = isEmpty || !!errorCount;
    setIsDisabled(isDisabled);
  }, [formData, formError]);

  useEffect(() => {
    formData && onChange(formData);
  }, [formData, onChange]);

  const handleChange = useCallback(
    (data: any, _: any) =>
      setFormData((prevFormData) => ({ ...prevFormData, ...data })),
    []
  );

  const handleSubmit = async () => {
    setIsLoading(true);
    formData && (await handleSave(formData));
    setIsLoading(false);
  };

  return (
    <Form
      className="row"
      onChange={handleChange}
      onSubmit={handleSubmit}
      onCheck={setFormError}
      model={InsuranceFormSchema}
      formValue={formData}
      fluid
    >
      <div className="col-md-10 col-12 border-end px-4 add-page-ctl">
        <div className="row">
          <TextInput
            name="name"
            required
            onChange={(val) =>
              setFormData((prev) =>
                prev ? { ...prev, name: val, displayName: val } : prev
              )
            }
          >
            Name
          </TextInput>
          <TextInput name="displayName" required>
            Display Name
          </TextInput>
        </div>

        {/* <div className="row">
          <TextInput name="code" required>
            Code
          </TextInput>
          <TagWriteInput name="insuranceCounty">Insurance County</TagWriteInput>
        </div> */}
        <div className="row">
          <TextInput name="payerID">
            Payer ID
          </TextInput>
          <TextInput name="subtitle" required>
            Sub title
          </TextInput>
        </div>

        <div className="row">
          <TagWriteInput name="insuranceCounty">Insurance County</TagWriteInput>
          <div className="col-md-4 d-flex align-items-center px-1">
            Is disabled{" "}
            <Toggle
              onChange={() =>
                setFormData((prev) =>
                  prev
                    ? {
                        ...prev,
                        isDisabled: !prev?.isDisabled,
                      }
                    : prev
                )
              }
              checked={!!formData?.isDisabled}
              size="sm"
              className="ms-2"
            />
          </div>
        </div>
      </div>

      <div className="col-md-2 col-12">
        <Button
          className="m-1 w-100 btn-green"
          type="submit"
          name="Save"
          loading={isLoading}
          disabled={isDisabled}
        />
        <Button
          onClick={() => {
            routeHistory.length > 1
              ? routeHistory.goBack()
              : routeHistory.push(AppRouteUi.Root);
          }}
          type="button"
          className="m-1 w-100 btn-green-subtle"
          disabled={isLoading}
          name="Return without saving"
        />
      </div>
    </Form>
  );
};
